import { createSlice } from "@reduxjs/toolkit";

const homeState = {
  homePageUI: null,
  homePageHistoryList: null,
  error: null,
  listLoading: false,
  actionsLoading: false,
  searchLoading: false,
  isRefresh: false,
};

export const homeSlice = createSlice({
  name: "home",
  initialState: homeState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error;

      if (action.payload.callType === "list") {
        state.listLoading = false;
      } else if (action.payload.callType === "action") {
        state.actionsLoading = false;
      } else if (action.payload.callType === "detail") {
        state.searchLoading = false;
      }
    },
    throwError: (state, action) => {
      state.error = action.payload.data.error;
    },
    startCall: (state, action) => {
      state.isRefresh = false;
      state.error = null;

      if (action.payload.callType === "list") {
        state.listLoading = true;
      } else if (action.payload.callType === "action") {
        state.actionsLoading = true;
      } else if (action.payload.callType === "detail") {
        state.searchLoading = true;
      }
    },
    clearError: (state) => {
      state.error = null;
    },
    homePageUIFetched: (state, action) => {
      state.listLoading = false;
      state.homePageUI = action.payload.data ?? {};
    },
    homePageMemberDataFetched: (state, action) => {
      state.listLoading = false;
      state.homePageMemberData = action.payload.data ?? {};
    },
  },
});
